import { createGlobalState } from '@vueuse/core';

export const useLessonRatingStore = createGlobalState(() => {

  const submit = (courseId: number, lessonId: number, rating: number) => {
    const url = useApiUrl('/courses/' + courseId + '/lessons/' + lessonId + '/ratings');
    return useAuthenticatedFetch(url, { method: 'POST', body: { rating }});
  };

  return {
    submit,
  };

});